import ShipmentForm from '../components/ShipmentForm';

const NewShipment = () => {
  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold mb-8">Add New Shipment</h1>
      <ShipmentForm />
    </div>
  );
};

export default NewShipment; 